<template>
    <main>
        <div class="createCampaignDiv">
            <h1 v-if="campaign.id === null">Create New Campaign</h1>
            <h1 v-if="campaign.id !== null">Edit Campaign</h1>
            <section>
                <label for="campaign-name">
                    Campaign Name
                </label>
                <input id="campaign-name" v-model="campaign.name" type="text" />
                <label for="campaign-description">
                    Campaign Description
                </label>
                <textarea
                    cols="68"
                    rows="5"
                    maxlength="310"
                    id="campaign-description"
                    v-model="campaign.description"
                ></textarea>
                <label for="campaign-description">
                    <div class="bannerUpload">
                        Campaign Banner Upload
                        <label class="file">
                            <input
                                type="file"
                                class="bannerImage"
                                @change="onBannerSelected"
                                @click="btnOnClick"
                                accept="image/*"
                            />
                            <span class="file-custom"></span>
                        </label>
                        <img
                            v-if="!value"
                            src="https://dummyimage.com/380x100/868cdb/FFFFFF"
                            alt=""
                            aria-placeholder="Select image to preview"
                        />
                        <div v-show="value">
                            <h3>Image Preview</h3>
                            <img :src="image" alt="" aria-placeholder="Select image to preview" />
                            <span>
                                <button id="uploadBtn" @click="uploadImage(campaign)">Upload</button>
                                <span
                                    ><img
                                        class="uploadOk"
                                        v-show="upload"
                                        src="../../../public/static/icons/icons8-ok-48.png"
                                /></span>
                            </span>
                        </div>
                    </div>
                </label>
                <div class="create">
                    <button v-if="campaign.id === null" @click="saveCampaign">Create</button>
                    <button v-else @click="saveCampaign">Save</button>
                    <router-link :to="{ name: 'campaign-list', params: { '0': 'campaign-list' } }" tag="button"
                        >Cancel</router-link
                    >
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import axios from 'axios';
import { addCampaign } from '../../core/api/files/files.js';

export default {
    data() {
        return {
            campaign: {
                id: null,
                name: '',
                owner: '',
                description: '',
                players: [],
                imageUrl: '',
            },
            selectedBanner: null,
            image: null,
            value: false,
            imageData: '',
            upload: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        if (to.params.id) {
            axios
                .get(`/api/campaigns/${to.params.id}`)
                .then(response => {
                    next(vueMethods => vueMethods.setData(response.data));
                })
                .catch(error => {
                    next(vueMethods => vueMethods.setError(error));
                });
        } else {
            next();
        }
    },
    methods: {
        setData(data) {
            this.campaign = data;
        },
        setError() {
            this.error = 'Error loading campaign to edit.';
        },
        saveCampaign() {
            let method = this.campaign.id ? 'put' : 'post';
            axios[method]('/api/campaigns', this.campaign).then(() => {
                this.$router.push('/');
            });
        },
        onBannerSelected(event) {
            this.upload = false;
            const selectedImage = event.target.files[0];
            this.imageData = event.target.files;
            this.createBase64Image(selectedImage);
        },
        createBase64Image(fileObject) {
            const reader = new FileReader();
            reader.readAsDataURL(fileObject);
            reader.onload = event => {
                this.image = event.target.result;
            };
        },
        uploadImage() {
            addCampaign(this.imageData).then(results => {
                this.campaign.imageUrl = results.data.files[0].url;
                this.upload = true;
                let btn = document.getElementById('uploadBtn');
                btn.style.backgroundColor = 'gray';
                btn.disabled = true;
            });
        },
        btnOnClick() {
            this.value = true;
        },
    },
};
</script>

<style lang="scss" scoped>
section {
    display: flex;
    flex-direction: column;
    max-width: 60ch;
}

// -- Create Campaign extra CSS
.createCampaignDiv {
    margin-left: auto;
    margin-right: auto;
    background-color: rgb(4, 24, 90);
    height: 65px;
    width: 500px;
    padding: 10px;
    padding-bottom: 0px;
    border-radius: 10px;
    color: white;
}

.createCampaignDiv h1 {
    padding: 0;
    margin-top: 5px;
    margin-left: 8px;
    margin-bottom: 25px;
}

//----------------------

input#campaign-name {
    position: relative;
    top: 10px;
}

.createCampaignDiv label {
    color: white;
    padding-top: 10px;
}

textarea {
    margin-bottom: 0.2rem;
    height: 80px;
    margin-top: 10px;
    white-space: pre-wrap;
}

input {
    margin-top: 0;
    margin-bottom: 1rem;
}

input[type='file'] {
    position: relative;
    top: 10px;
    margin-bottom: 50px;
}

label {
    font-weight: bold;
    font-size: 1.2em;
}

main {
    padding: 2rem;
}

button:first-child {
    margin-right: 1rem;
}

button:nth-child(2) {
    background-color: transparent;
    color: white;
}

.bannerUpload button {
    border: 0.5px solid white;
    background-color: rgb(4, 24, 90);
    position: relative;
    top: 10px;
}

.bannerImage::-webkit-file-upload-button {
    background-color: rgb(4, 24, 90);
    color: white;
    border: 0;
    padding: 10px;
    border-radius: 10px;
    border: 0.5px solid white;
    cursor: pointer;
}

section {
    border: 0.5px solid white;
    padding: 10px;
    border-radius: 10px;
    width: 100%;
    margin-left: -10px;
}

.create {
    margin: 0;
    padding: 4px;
    border-radius: 6px;
    background-color: rgb(4, 24, 90);
}

input[type='file'] {
    margin-left: -10px;
    margin-bottom: 20px;
}

section h3 {
    margin: 0;
}

section img:placeholder-shown {
    color: white;
}

section img {
    width: 350px;
    height: 100px;
    border: 2px dashed white;
    border-radius: 10px;
}

span {
    position: relative;
    top: -24px;
    left: 10px;
}

section span .uploadOk {
    width: 48px;
    height: 48px;
    border: none;
    position: relative;
    top: 50px;
    right: 15px;
}
</style>
